
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { setupFetchLogger } from './utils/fetchLogger';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './providers/AuthProvider';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import { supabase } from '@/integrations/supabase/client';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

// Only enable debugging features in development environment
if (process.env.NODE_ENV === 'development') {
  setupFetchLogger();
  // Enable Supabase debugging only in development
  // Use type assertion to access debug property since it's not in the type definition
  (supabase as any).debug = true;
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>,
);
